// extracted by mini-css-extract-plugin
export var pillWrapper = "_ys-0";
export var showOverflow = "_ys-1";